var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
var TabWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  height: 40px;\n  padding: 0 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 0;\n  background: transparent;\n  border-radius: 6px 6px 0px 0px;\n\n  :not(:first-child) {\n    margin-left: 1px;\n  }\n\n  ", "\n"], ["\n  position: relative;\n  height: 40px;\n  padding: 0 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 0;\n  background: transparent;\n  border-radius: 6px 6px 0px 0px;\n\n  :not(:first-child) {\n    margin-left: 1px;\n  }\n\n  ",
    "\n"])), function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return checked
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          background: ", ";\n          box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.05);\n          z-index: 1;\n        "], ["\n          background: ", ";\n          box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.05);\n          z-index: 1;\n        "])), theme.colorsNew.gray.graySLight) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "])), theme.colorsNew.gray.grayMedium);
});
var Input = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n\n  :disabled,\n  :checked {\n    cursor: default;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n\n  :disabled,\n  :checked {\n    cursor: default;\n  }\n"])));
/**
 * An accessible `Tab` element according to WAI-ARIA guidelines.
 *
 * **MUST** have a `Tabs` ancestor in order to work.
 *
 * @see [This WAI-ARIA example](https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/tabs.html).
 */
export function Tab(_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(TabWrapper, { checked: rest.checked },
        children,
        React.createElement(Input, __assign({ type: "radio" }, rest))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
